module.exports = __webpack_public_path__ + "static/media/Arrow_Right_White.c0547804.svg";